<template>
  <div
    class="SchoolUnitList">
    <UnitCodeCriteria
      :baseCrudKey="baseCrudKey"
      @loadCRUDList="handleLoadCRUDList"
    />
    <CRUDList
      :canAdd="true"
      :canEdit="true"
      :canSave="true"
      :headers="headers"
      :showDate="true"
      :showTotal="true"
      :baseCrudKey="baseCrudKey"
      :createNewItem="newItemDialog"
      :defaultSortBy="sortBy"
      toolbarTitle="School/Unit Code"
      @loadCRUDList="handleLoadCRUDList"
      @upsertItem="upsrtSchool"
      >
      <template v-slot:[`additionalToolsAtRight`]="{}">
        <span v-if="isSuperAdmin">
        <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
            <v-btn
              depressed
              color="primary"
              v-bind="attrs"
              v-on="on"
              id="autoCreateMiscUnitCodebtn"
              class="misc-unit-code-auto-create-btn"
              @click="autoCreateMiscUnitCodesFromTaxUnit"
            >
            Auto Create Misc Unit Code
            </v-btn>
          </template>
          <span>Auto Create Misc Unit Code From Tax Unit General</span>
        </v-tooltip>
      </span>
      </template>
      <template v-slot:[`editedItem`]="{}">
        <UnitCodeEditedItem :baseCrudKey="baseCrudKey"/>
      </template>
    </CRUDList>
  </div>
</template>

<script>
import {
  mapGetters,
  mapActions,
  mapState,
  mapMutations,
} from 'vuex';
import CRUDList from '../../common/base/crud/CRUDList.vue';
import UnitCodeCriteria from './UnitCodeCriteria.vue';
import UnitCodeEditedItem from './UnitCodeEditedItem.vue';
import {
  toFiscalYear,
} from '../../../util/shared/tmc-global';
import { isAuthorised } from '../../../store/auth/token';
import { authRoles } from '../../../router/roleGroups';

const getHeaders = () => {
  const headers = [
    { text: 'Unit Code', value: 'unitCode' },
    { text: 'Unit Code Number', value: 'unitCodeNumber' },
    { text: 'Description', value: 'description' },
  ];
  return headers;
};

export default {
  data: () => ({
    baseCrudKey: 'miscUnitCode',
    headers: [],
    sortBy: [
      {
        column: 'unitCodeNumber',
        direction: 'asc',
      },
    ],
  }),
  created() {
    this.headers = getHeaders();
    this.initCriteria();
    this.loadFiscalRegYears();
    this.criteriaState.fiscalYear = toFiscalYear(new Date(this.todaysDate));
  },
  components: {
    CRUDList,
    UnitCodeCriteria,
    UnitCodeEditedItem,
  },
  computed: {
    ...mapGetters('base/crud', [
      'criteria',
      'index',
      'items',
    ]),
    ...mapGetters(['todaysDate']),
    ...mapState({
      sourceType: (state) => {
        const sourceTypeVals = state.enums.cmnSourceTypeEnum || [];
        return [{ name: null, description: '' }, ...sourceTypeVals];
      },
    }),
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
    isSuperAdmin() {
      return isAuthorised(authRoles.SuperAdmin);
    },
  },
  methods: {
    ...mapActions('misc/schoolUnit', [
      'loadMiscUnitCode',
      'upsertMiscUnitCode',
      'loadFiscalRegYears',
      'autoCreateMiscUnitCodeFromTaxUnit',
    ]),
    ...mapActions({
      flashSuccess: 'flashSuccess',
      flashError: 'flashError',
    }),
    ...mapMutations('base/crud', [
      'setCriteria',
    ]),
    handleLoadCRUDList(criteriaArgs = {}) {
      const { baseCrudKey } = this;
      const criteria = this.criteriaState;
      this.loadMiscUnitCode({
        criteria,
        baseCrudKey,
        criteriaArgs,
      });
    },
    isNewItem() {
      return this.index(this.baseCrudKey) === -1;
    },
    upsrtSchool(item) {
      const { baseCrudKey } = this;
      if (!this.isNewItem()) {
        if (!window.confirm('This update will reflect to all associated places, are you sure!')) {
          return false;
        }
      }
      this.upsertMiscUnitCode({ item, baseCrudKey });
      return true;
    },
    initCriteria() {
      // reset criteria while merge flag is true
      this.criteriaState = {};
    },
    newItemDialog() {
      let newItem = {};
      newItem = {
        fiscalYear: toFiscalYear(new Date(this.todaysDate)),
        unitCode: null,
        unitCodeNumber: null,
        description: null,
      };
      return newItem;
    },
    async autoCreateMiscUnitCodesFromTaxUnit() {
      const miscUnitCodesArr = this.items(this.baseCrudKey) || [];
      if (window.confirm('Are you sure you want to auto create misc unit codes from Tax Unit generals?')) {
        const autoCreateUpsertResponse = await this.autoCreateMiscUnitCodeFromTaxUnit({
          params: {
            miscUnitCodesArr,
            fiscalYear: this.criteriaState.fiscalYear,
          },
        });
        const { ok, nInserted } = autoCreateUpsertResponse.data
          .upsertAutoCreateMiscUnitCodeFromTaxUnitDetails.result;
        if (!ok) {
          this.$store.dispatch('flashError', 'Some error occured while auto creating misc unit codes from Tax Units General.');
        } else if (ok === 1 && nInserted > 0) {
          this.$store.dispatch('flashSuccess', 'Successfully auto create misc unit codes from Tax Units General');
          this.handleLoadCRUDList();
        } else {
          this.$store.dispatch('flashError', 'All Misc unit codes already present from Tax Units General.');
        }
      }
    },
  },
};
</script>
